module.exports = __webpack_public_path__ + "5c8a3643c3931d0b8e03c670e2e02478.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/termine/CoronaBar.jpg
// module id = 697
// module chunks = 0